"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Promotion = void 0;
const moment_1 = __importDefault(require("moment"));
class Promotion {
    constructor(data) {
        this.isActive = () => {
            const nowToday = (0, moment_1.default)();
            return !(!this.entryStart ||
                nowToday < (0, moment_1.default)(this.entryStart) ||
                (!!this.entryEnd && nowToday > (0, moment_1.default)(this.entryEnd)));
        };
        this.isComingSoon = () => {
            const nowToday = (0, moment_1.default)();
            return !!this.entryStart && (0, moment_1.default)(this.entryStart).isAfter(nowToday);
        };
        this.isEndingSoon = () => {
            const nowToday = (0, moment_1.default)();
            return (!!this.endingSoon &&
                !!this.entryEnd &&
                (0, moment_1.default)(this.endingSoon).isBefore(nowToday) &&
                (0, moment_1.default)(this.entryEnd).isAfter(nowToday));
        };
        this.isEnded = () => {
            const nowToday = (0, moment_1.default)();
            return !!this.entryEnd && (0, moment_1.default)(this.entryEnd).isBefore(nowToday);
        };
        this.getPromotionStatus = () => {
            let promotionStatus = '';
            if (this.isEnded()) {
                promotionStatus = 'ENDED';
            }
            else if (this.isEndingSoon()) {
                promotionStatus = 'ENDING_SOON';
            }
            else if (this.isComingSoon()) {
                promotionStatus = 'COMING_SOON';
            }
            return promotionStatus;
        };
        this.isJackpotReached = () => !!this.progressivePrize &&
            !!this.progressivePrize.ceiling &&
            !!this.progressivePrize.value &&
            this.progressivePrize.value >= this.progressivePrize.ceiling;
        this.id = data.id;
        this.name = data.name;
        this.posImage = data.posImage;
        this.fullImage = data.fullImage;
        this.description = data.description;
        this.promotionType = data.promotionType;
        this.additionalInformation = data.additionalInformation;
        this.mobileAdditionalInformation = data.mobileAdditionalInformation;
        this.rulesDocument = data.rulesDocument;
        this.start = data.start;
        this.end = data.end;
        this.order = data.order;
        this.entryStart = data.entryStart;
        this.entryEnd = data.entryEnd;
        this.endingSoon = data.endingSoon;
        this.progressivePrize = null;
        this.progressiveDrawDate = null;
        this.progressiveEntryEndDate = null;
        this.progressiveDrawNumber = null;
    }
}
exports.Promotion = Promotion;
Promotion.JsonToEntities = (data) => data.map(Promotion.JsonToEntity);
Promotion.JsonToEntity = (data) => new Promotion(data);
//# sourceMappingURL=Promotion.js.map